import { useTranslations } from "next-intl";
import React, { FC, useContext, useMemo } from "react";

import { AvailableUnitContext, Params } from "@/context/AvailableUnitListContext";
import { Facet, FacetValue } from "@/types";

interface Props {
  filter: Facet;
  closeHandler?: () => void;
}
const IconFilters: FC<Props> = ({ filter, closeHandler }) => {
  const t = useTranslations();
  const filterKey = useMemo(() => {
    return Object.keys(filter)[0];
  }, [filter]);
  const { params, dispatch } = useContext(AvailableUnitContext);
  return (
    <>
      {filter[filterKey].map((facet: FacetValue) => {
        const selected = params[filterKey as keyof Params] === facet.value;
        const buttonClass = `${facet.enabled && selected ? "bg-gold" : facet.enabled && !selected ? "bg-white hover:bg-gold" : "bg-gray-7"}`;
        return (
          <button
            onClick={() => {
              if (selected) {
                dispatch({ update: "UPDATE", payload: { [filterKey]: undefined } });
              } else {
                dispatch({ update: "UPDATE", payload: { [filterKey]: facet.value } });
              }
              closeHandler && closeHandler();
            }}
            disabled={!facet.enabled}
            className={`transition-colors p-s rounded-lg border border-gray-10 ${buttonClass} ${!facet.enabled ? "opacity-45" : ""}`}
            key={`button-${filterKey}-${facet.value}`}
          >
            {facet.value}
          </button>
        );
      })}
    </>
  );
};
export default IconFilters;
